import styled, { css } from 'styled-components';

export const HiddenInput = styled.input`
  display: none;
`;

export const ImagePreview = styled.img`
  width: 100%;
  object-fit: contain;
  height: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 16px;
  border-top: 1px solid #ccc;
  background-color: white;
  border-radius: 0 0 20px 20px;
  height: 60px;
  align-items: center;
  box-sizing: border-box;
`;

export const ImageInputContainer = styled.div<{ hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 20px;
  margin-bottom: 4px;
  ${({ hasError }) =>
    hasError &&
    css`
      border-color: #ff1515;
    `}
`;

export const ImageContainer = styled.div<{
  imageUploaded: boolean;
  orientation: 'square' | 'portrait' | 'landscape';
  isDragging?: boolean;
  disabled?: boolean;
}>`
  ${({ orientation }) => {
    switch (orientation) {
      case 'square':
        return 'aspect-ratio: 1/1;';
      case 'portrait':
        return 'aspect-ratio: 9/16;';
      case 'landscape':
        return 'aspect-ratio: 16/9;';
      default:
        return 'aspect-ratio: 1/1;';
    }
  }}
  ${({ isDragging }) =>
    css`
      background-color: ${isDragging ? '#fff6e9' : 'white'};
    `}
  ${({ imageUploaded }) =>
    imageUploaded
      ? css`
          border-radius: 20px 20px 0 0;
        `
      : css`
          border-radius: 20px;
          padding-bottom: 60px;
        `}
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const NoImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: relative;
  top: 30px;
`;

export const NoImageTextContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: ${({ theme, disabled }) => (disabled ? theme.grayCC : theme.gray4D)};
  p {
    margin: 0;
    font-size: 14px;
    color: ${({ theme, disabled }) => (disabled ? theme.grayCC : theme.gray80)};
  }
`;

export const ImageNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  p {
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => theme.gray4D};
  }
`;
